import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { TefProductCodeUpdateValidationSchema } from '../schemas/tefProductCode.schema';

interface UseUpdateTefProductProps {
  id?: string;
  productId?: string;
  provider?: string;
  onSuccess: (response: AxiosResponse) => void;
  onError: (error: ErrorResponse) => void;
}

export const useUpdateTefProductCode = ({ id, productId, provider, onSuccess, onError }: UseUpdateTefProductProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['updateTefProductCode'],
    mutationFn: async (form: TefProductCodeUpdateValidationSchema) => {
      const payload = {
        tef_product_code: {
          code: form.code,
          product_id: productId,
          provider,
        }
      }

      return privateAxios.put(`/tef_product_codes/${id}`, payload);
    },
    onSuccess,
    onError,
  });
}
